import React from "react"
import { Col, Flex, Row, Tag, Typography } from "antd"
import { AppstoreAddOutlined } from "@ant-design/icons"
import { useWizardContext } from "../../../WizardContext"
import styles from "./PreviewAddOns.module.css"

const { Title, Text } = Typography

const CATEGORY_LABELS = {
  equipment: "Equipment",
  gear: "Gear",
  other: "Other"
}

export const PreviewAddOns = () => {
  const { form } = useWizardContext()
  const addOns = form.getFieldValue("add_ons") || []
  const activeAddOns = addOns.filter((a) => a.enabled !== false)

  if (activeAddOns.length === 0) return null

  return (
    <div className={styles.container}>
      <Title level={3} className={styles.title}>{"Add-Ons"}</Title>

      <Row gutter={[12, 12]}>
        {activeAddOns.map((addOn) => (
          <Col xs={24} sm={12} key={addOn.id}>
            <div className={styles.card}>
              {addOn.photo && (
                <img src={addOn.photo} alt={addOn.title} className={styles.photo} />
              )}
              <div className={styles.cardBody}>
                <Flex justify="space-between" align="flex-start" gap="small">
                  <Text strong className={styles.cardTitle}>{addOn.title}</Text>
                  <Text strong className={styles.price}>{`$${Number(addOn.price ?? 0).toFixed(2)}`}</Text>
                </Flex>
                {addOn.category && (
                  <Tag className={styles.categoryTag}>{CATEGORY_LABELS[addOn.category] ?? addOn.category}</Tag>
                )}
                {addOn.description && (
                  <Text className={styles.description}>{addOn.description}</Text>
                )}
                {(addOn.minPerOrder != null || addOn.maxPerOrder != null) && (
                  <Flex align="center" gap="small" className={styles.rangeRow}>
                    <AppstoreAddOutlined className={styles.rangeIcon} />
                    <Text className={styles.rangeText}>
                      {`Min ${addOn.minPerOrder ?? 0} – Max ${addOn.maxPerOrder ?? "∞"} per order`}
                    </Text>
                  </Flex>
                )}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  )
}
